// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"AppLayoutHeader_pageTitle__IbQ_2","profileslide":"AppLayoutHeader_profileslide__2gLic"};